import { Container } from 'inversify'

import { Basketball3x3IncidentId } from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindIncidentsResultConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.IncidentsResultConfiguration)
    .toDynamicValue(() => {
      return {
        scoringIncidents: new Map([
          [Basketball3x3IncidentId.OnePointShotMade, { add: 1, visible: true }],
          [Basketball3x3IncidentId.FreeThrowIn, { add: 1, visible: true }],
          [Basketball3x3IncidentId.TwoPointShotMade, { add: 2, visible: true }],
        ]),
      }
    })
    .inSingletonScope()
}
